/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_No_AccountInputs */

const en_common_sign_no_account = /** @type {(inputs: Common_Sign_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const zh_common_sign_no_account = /** @type {(inputs: Common_Sign_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有账号？`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Common_Sign_No_AccountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_no_account = /** @type {((inputs?: Common_Sign_No_AccountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_No_AccountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_no_account(inputs)
	return zh_common_sign_no_account(inputs)
});
export { common_sign_no_account as "common.sign.no_account" }